/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ClipboardCheckFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="clipboard-check-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M17.5 3C18.605 3 19.5 3.895 19.5 5L19.5 19.5C19.5 20.605 18.605 21.5 17.5 21.5L6.5 21.5C5.395 21.5 4.5 20.605 4.5 19.5L4.5 5C4.5 3.895 5.395 3 6.5 3L8.534 3C8.383 3.419 8.283 3.858 8.25 4.25L8 4.25C7.034 4.25 6.25 5.034 6.25 6C6.25 6.966 7.034 7.75 8 7.75L16 7.75C16.966 7.75 17.75 6.966 17.75 6C17.75 5.034 16.966 4.25 16 4.25L15.75 4.25C15.717 3.858 15.617 3.419 15.466 3L17.5 3ZM8.2 14.609L10.321 16.73C10.424 16.844 10.559 16.932 10.717 16.979C10.958 17.051 11.205 17.015 11.406 16.898C11.471 16.861 11.532 16.814 11.588 16.759C11.705 16.642 11.782 16.5 11.818 16.35C12.174 15.152 12.74 14.133 13.527 13.189C13.925 12.712 14.339 12.305 14.826 11.915C15.313 11.525 16.517 10.822 16.517 10.822C16.741 10.605 16.831 10.284 16.754 9.982C16.677 9.679 16.443 9.441 16.143 9.358C15.844 9.276 15.524 9.358 15.302 9.574C15.301 9.576 15.299 9.577 15.298 9.579C15.298 9.579 13.089 10.981 12.183 12.068C11.57 12.804 11.041 13.66 10.632 14.565L9.438 13.371C9.096 13.03 8.542 13.03 8.2 13.371C7.859 13.713 7.859 14.267 8.2 14.609Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M10 5.75L10 4.25C10 3.145 10.895 2.25 12 2.25C13.105 2.25 14 3.145 14 4.25L14 5.75" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8 6L16 6" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
